<div class="login-redirect">
  <p>Redirecting to sign in…</p>
</div>
